import { _$api } from '/opt/buildhome/repo/node_modules/nuxt-api-party/dist/runtime/composables/$api'
import { _useApiData } from '/opt/buildhome/repo/node_modules/nuxt-api-party/dist/runtime/composables/useApiData'
export const $apiFetch = (...args) => _$api('apiFetch', ...args)
export const useApiFetchData = (...args) => _useApiData('apiFetch', ...args)
